import React from 'react';
import { FormSubmitButton } from '@digital/ui';

export default (props: React.ComponentProps<typeof FormSubmitButton>) => (
  <FormSubmitButton type="link" icon="files-ms_excel" responsive {...props}>
    EXCEL
  </FormSubmitButton>
);
